import { LOCALES } from '../locales';

export default {
	[LOCALES.GERMAN]: {
		'hello': 'Hallo, {name}!',
		'TÜM TERMİNALLER':'ALLE TERMINALS',
        'BÖLÜM BAZINDA': 'ABTEILUNG BASIEREND',
        'FİLTRE BAZINDA': 'AUF FILTERBASIS',
		'Bildiren':'Meldung',
        'Renk':'Farbe',       
        'Sicil':'Melderegister',
        'Parça':'Teil',
        'Hata':'Fehler',
        'Saat':'Uhrzeit',
        'Hata Türü':'Fehlertyp',
        'Hata Sor':'Fehlerverantwortlicher',
        'Alt Sorumlu':'Unterverantwortlicher',
        'Kaydet':'Speichern',
        'İşlem':'Vorgang',
        'MONTAJ NO':'MONTAGE-NR.',
        'BODY NO':'BODY NR.',
        'ARA':'Suchen',
        'Teknik Destek':'Technische Unterstützung',
        'ARAÇ LİSTESİ':'FAHRZEUG-LISTE',
        'MANUEL HATA':'MANUELLER FEHLER',
        'ÇOKLU HATA':'MEHRFACHE FEHLER',
        'HATA LİSTESİ':'FEHLERLISTE',
        'HATA KOPYA': 'FEHLERKOPIE',
        'ÇIKIŞ': 'Ausgang',
        'Toplam satır':'Gesamtzeilen',
        'HATA GİRİŞ EKRANI':'FEHLEREINGABEBILDSCHIRM',
        'HIZLI KAYDET':'Schnellspeichern',
        'KAYDET VE GEÇ':'Speichern und Weiter',
        'HATA KAYIT':'FEHLERERFASSUNG',
        'TERMİNAL İLK RESMİ':'TERMINAL ERSTES BILD',
        'SIK GELEN HATA':'HÄUFIG AUFTRETENDER FEHLER',
        'MANİFEST':'MANIFEST',
        'MODEL İLK RESMİ':'MODELL ERSTES BILD',
        'GERİ':'Zurück',
        'TEMİZLE':'Löschen',
        'HATA LİSTESİ':'FEHLERLISTE',
        'BÜYÜK FONT':'Große Schriftart',
        'Harigami':'Harigami',
        'Tarih':'Datum',
        'Terminal Listesi':'Terminal Liste',
        'Sicil No':'Melderegister-Nr.',
        'Şifre':'Passwort',
        'Giriş Yap':'Einloggen',
        'Kapat':'Schließen',
        'Montaj No':'Montage-Nr.',
        'Vardiya':'Schicht',
        'Girdiğiniz bilgiler hatalıdır!':'Die eingegebenen Informationen sind falsch!',
        'Giriş yapılıyor...':'Einloggen...',
        'Açıklama':'Beschreibung',
        'Yapılan İşlem':'Durchgeführter Vorgang',
        'Çıkış Departmanı':'Austrittsabteilung',
        'Hata Sınıfı':'Fehlerklasse',
        'Sık Gelen Hata':'Häufig auftretender Fehler',
        'Hata Sorumlusu':'Fehlerverantwortlicher',
        'Kaydedildi':'Gespeichert',
        'Örnek açıklama':'Beispielbeschreibung',
        'İptal':'Stornieren',
        'RENK':'FARBE',
        'HATA GİRİŞİ':'FEHLEREINGABE',
	}
}